export default "__VITE_ASSET__deUwuVOD__"